import { tailwindPalette } from "../../../../../theme/tailwindPalette"

// Ordered palette for tenant ranks: a single monotonic blue ramp (dark navy -> light blue),
// matching the mockup. All values come from design tokens (no raw hex in components).
const tenantRankColors: ReadonlyArray<string> = [
    tailwindPalette.blue[950],
    tailwindPalette.blue[900],
    tailwindPalette.blue[800],
    tailwindPalette.blue[700],
    tailwindPalette.blue[600],
    tailwindPalette.blue[500],
    tailwindPalette.blue[400],
    tailwindPalette.blue[300],
]

// Aggregated "other tenants" bucket.
export const otherTenantsColor = tailwindPalette.slate[300]

export function colorForRank(rank: number): string {
    return tenantRankColors[rank] ?? otherTenantsColor
}
